import { AUTHORITIES } from 'app/config/constants';
import PrivateRoute from 'app/shared/auth/private-route';
import React from 'react';
import { Switch } from 'react-router-dom';
import UserCustom from './user-custom';
import UserCustomDeleteDialog from './user-custom-delete-dialog';
import UserCustomDetail from './user-custom-detail';
import UserCustomUpdate from './user-custom-update';

const Routes = ({ match }) => (
  <>
    <Switch>
      <PrivateRoute
        exact
        path={`${match.url}/new`}
        component={UserCustomUpdate}
        hasAnyAuthorities={[AUTHORITIES.ADMIN, AUTHORITIES.MANUFACTURER_ADMIN]}
      />
      <PrivateRoute
        exact
        path={`${match.url}/:id/edit`}
        component={UserCustomUpdate}
        hasAnyAuthorities={[AUTHORITIES.ADMIN, AUTHORITIES.MANUFACTURER_ADMIN]}
      />
      <PrivateRoute
        exact
        path={`${match.url}/:id`}
        component={UserCustomDetail}
        hasAnyAuthorities={[AUTHORITIES.ADMIN, AUTHORITIES.MANUFACTURER_ADMIN]}
      />
      <PrivateRoute path={match.url} component={UserCustom} hasAnyAuthorities={[AUTHORITIES.ADMIN, AUTHORITIES.MANUFACTURER_ADMIN]} />
    </Switch>
    <PrivateRoute exact path={`${match.url}/:id/delete`} component={UserCustomDeleteDialog} hasAnyAuthorities={[AUTHORITIES.ADMIN]} />
  </>
);

export default Routes;
